import { Command as CommandPrimitive } from 'cmdk';
import React from 'react';

import { cn } from '@/services/utils';

const Command = React.forwardRef<
    React.ElementRef<typeof CommandPrimitive>,
    React.ComponentPropsWithoutRef<typeof CommandPrimitive>
>(({ className, ...props }, ref) => (
    <CommandPrimitive
        ref={ref}
        className={cn(
            'tw-flex tw-h-full tw-w-full tw-flex-col tw-overflow-hidden tw-rounded-md tw-bg-white tw-text-black',
            className
        )}
        {...props}
    />
));

Command.displayName = CommandPrimitive.displayName;

export { Command };
